import type { SidebarSide } from './types';

export const getCallbackResultDependingOnSidebarSide = <T>(
  sidebarSide: SidebarSide,
  sideToCallbackRelations: Record<SidebarSide, () => T>
) => {
  return sideToCallbackRelations[sidebarSide]();
};
